import { Route } from '@angular/router';

import { ForgotUsernameComponent } from './forgot-username.component';

export const forgotUsernameRoute: Route = {
    path: 'usernameDimenticato',
    component: ForgotUsernameComponent,
    data: {
        pageTitle: 'pagetitles.forgotusername'
    }
};
